import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from 'app/area/case/endpoints';

export interface CreateCaseDraftData {
  caseTypeId?: number;
  caseId?: number;
  caseIdToDuplicate?: number;

  copyFrom?: {
    source: {
      caseId?: number;
      draftId?: number;
    },
    context: {
      connectionTypeId?: number
    }
  };
}

export const api = {
  
  createCase: async (
    bodyParameters: CreateCaseDraftData, 
    queryParameters?: {[key:string]: string | number},
    captchaToken?: string 
  ): Promise<number> => {
    return await new RemoteData(endpoint.draft)
      .resource<any>()
      .withHeader('g-recaptcha-response', captchaToken)
      .filter({
        ...queryParameters,
        includeDraftData: false
      })
      .create(bodyParameters, true);
  }
};
